import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'antd';
import useAccountTypes from '../../../../../queries/useAccountTypes';
import { actions, selectors } from '../../../model';
import { uploadingFieldNames } from '../../../config/uploadingStep';
import FormItem from '../../ui/FormItem/FormItem';

const { accountTypeChangeAction } = actions;
const { selectUploadingStepError, selectUploadingStepValue } = selectors;

const fieldName = uploadingFieldNames.accountType;
const valueSelector = (state) => selectUploadingStepValue(state, fieldName);
const errorSelector = (state) => selectUploadingStepError(state, fieldName);

const AccountTypeSelect = () => {
  const value = useSelector(valueSelector);
  const errors = useSelector(errorSelector);
  const dispatch = useDispatch();

  const { data: accountTypes, isFetching } = useAccountTypes({
    staleTime: Infinity,
  });

  const handleChange = (value) => dispatch(accountTypeChangeAction(value));

  return (
    <FormItem
      required
      label="Тип ЛС"
      errors={errors}
    >
      <Select
        value={value}
        style={{ width: '100%' }}
        onChange={handleChange}
        loading={Boolean(isFetching)}
        placeholder="Выберите тип ЛС"
      >
        {accountTypes
          ?.filter(({ id }) => id !== 0)
          .map(({ id, name }) => (
            <Select.Option
              value={id}
              key={id}
            >
              {name}
            </Select.Option>
          ))}
      </Select>
    </FormItem>
  );
};

export default AccountTypeSelect;
